export const conditionalItems = {
  title: 'Hàng điều kiện',
  resourceName: 'Hàng điều kiện',
  titles: {
    list: 'Danh sách hàng điều kiện',
    create: 'Thêm hàng điều kiện',
    edit: 'Sửa hàng điều kiện',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    basic: 'Thông tin cơ bản',
    linkage: 'Thông tin liên kết doanh nghiệp',
    validity: 'Hiệu lực và trạng thái',
    note: 'Ghi chú',
    audit: 'Thông tin hệ thống',
  },
  units: {
    days: 'ngày',
  },
  fields: {
    code: 'Mã hàng điều kiện',
    name: 'Tên hàng điều kiện',
    conditionGroup: 'Nhóm hàng điều kiện',
    groupName: 'Nhóm',
    conditionName: 'Tên điều kiện',
    productCode: 'Mã sản phẩm liên kết',
    sampleItem: 'Mặt hàng ví dụ',
    registeredCompany: 'Công ty đăng ký GCN',
    exporterCompany: 'Công ty xuất khẩu',
    importerCompany: 'Công ty nhập khẩu',
    sampleTestRequired: 'Yêu cầu test mẫu',
    certificate: 'GCN',
    licenseNumber: 'Số giấy phép',
    effectiveDate: 'Ngày áp dụng chạy',
    expiryDate: 'Ngày hết hạn',
    warningDays: 'Thời gian cảnh báo',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật / Tắt',
    note: 'Note',
    remark: 'Ghi chú',
    actions: 'Hành động',
  },
  filter: {
    country: 'Phân loại công ty',
    allCountries: 'Tất cả',
  },
  countries: {
    VN: 'Việt Nam',
    TQ: 'Trung Quốc',
  },
  status: {
    active: 'Đang hoạt động',
    inactive: 'Ngừng hoạt động',
    required: 'Bắt buộc',
    notRequired: 'Không bắt buộc',
  },
  validation: {
    conditionNameRequired: 'Vui lòng nhập tên điều kiện',
    companyRequired: 'Vui lòng chọn đủ 3 công ty',
  },
  messages: {
    importDescription: 'Chọn file Excel đúng mẫu để nhập hàng điều kiện.',
    importSuccess: 'Import hàng điều kiện thành công',
    importFailed: 'Import hàng điều kiện thất bại',
    exportSuccess: 'Xuất dữ liệu thành công',
    exportFailed: 'Xuất dữ liệu thất bại',
    noData: 'Không có dữ liệu hàng điều kiện',
    totalItems: 'Tổng: {total} hàng điều kiện',
    createSuccess: 'Tạo hàng điều kiện thành công',
    updateSuccess: 'Cập nhật hàng điều kiện thành công',
    deleteSuccess: 'Xóa hàng điều kiện thành công',
    confirmDelete: 'Bạn có chắc muốn xóa mục này?',
  },
  import: {
    button: 'Import',
    noSheet: 'File import không có sheet dữ liệu',
    noData: 'Không có dữ liệu để import',
    success: 'Import thành công {count} dòng',
    failed: 'Import thất bại',
  },
}
